import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const API_URL = process.env.REACT_APP_API_URL;

function getApiKeyMap() {
  try {
    return JSON.parse(localStorage.getItem('adminApiKeyMap')) || {};
  } catch {
    return {};
  }
}
function setApiKeyMap(map) {
  localStorage.setItem('adminApiKeyMap', JSON.stringify(map));
}

const initialState = {
  isAuthenticated: false,
  admin: null,
  token: null,
  isLoading: false,
  isSuccess: false,
  error: null,
  apiKey: null,
};

export const adminLogin = createAsyncThunk(
  'adminLogin',
  async (params, thunkApi) => {
    try {
      const response = await fetch(`${API_URL}/auth/signin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || 'Login failed');
      }
      if (data.role !== 'admin') {
        throw new Error('Not an admin account');
      }
      return data;
    } catch (err) {
      return thunkApi.rejectWithValue(err.message || 'Something went wrong');
    }
  }
);

export const adminLogout = createAsyncThunk('adminLogout', async (_, thunkApi) => {
  return {};
});

const adminAuthSlice = createSlice({
  name: 'adminAuth',
  initialState,
  reducers: {
    clearAdminAuthStatus: (state) => {
      state.isSuccess = false;
      state.error = null;
    },
    setAdminApiKey: (state, action) => {
      // Store apiKey per admin
      const admin = state.admin;
      const adminId = admin?.id || admin?.email;
      if (!adminId) return;
      let map = getApiKeyMap();
      if (action.payload) {
        map[adminId] = action.payload;
        state.apiKey = action.payload;
      } else {
        delete map[adminId];
        state.apiKey = null;
      }
      setApiKeyMap(map);
    },
    updateAdminProfileFields: (state, action) => {
      if (!state.admin) return;
      const { firstName, lastName } = action.payload;
      if (firstName !== undefined) state.admin.firstName = firstName;
      if (lastName !== undefined) state.admin.lastName = lastName;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(adminLogin.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(adminLogin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.admin = action.payload;
        state.token = action.payload?.token;
        state.isSuccess = true;
        state.isAuthenticated = true;
        state.error = null;
        // Load apiKey for this admin
        const adminId = action.payload?.id || action.payload?.email;
        const map = getApiKeyMap();
        state.apiKey = adminId ? map[adminId] || null : null;
      })
      .addCase(adminLogin.rejected, (state, action) => {
        state.isLoading = false;
        state.isAuthenticated = false;
        state.admin = null;
        state.token = null;
        state.error = action.payload;
        state.apiKey = null;
      })
      .addCase(adminLogout.fulfilled, (state) => {
        state.isLoading = false;
        state.isAuthenticated = false;
        state.isSuccess = true;
        state.admin = null;
        state.token = null;
        // Do NOT clear apiKey map on logout
      });
  },
});

export const { clearAdminAuthStatus, setAdminApiKey, updateAdminProfileFields } = adminAuthSlice.actions;
export const selectAdminAuth = (state) => state.adminAuth;
export default adminAuthSlice.reducer; 